import { render, staticRenderFns } from "./autocomplete-text.vue?vue&type=template&id=0563d793&scoped=true&"
import script from "./autocomplete-text.component.ts?vue&type=script&lang=ts&"
export * from "./autocomplete-text.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0563d793",
  null
  
)

export default component.exports